
import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { GripVertical, Save } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { GroupedLeagues } from './types';

interface LeagueListProps {
  groupedLeagues: GroupedLeagues;
  onDragEnd: (result: any) => void;
  onSave: () => void;
}

export const LeagueList = ({ groupedLeagues, onDragEnd, onSave }: LeagueListProps) => {
  return (
    <>
      <div className="flex justify-end mb-4">
        <Button onClick={onSave} className="flex items-center gap-2">
          <Save className="h-4 w-4" />
          Save League Order
        </Button>
      </div>
      
      <Accordion type="single" collapsible className="space-y-4">
        {Object.entries(groupedLeagues).map(([country, countryLeagues]) => (
          <AccordionItem value={country} key={country} className="bg-background rounded-lg border">
            <AccordionTrigger className="px-4">
              <span className="text-lg font-medium">{country}</span>
            </AccordionTrigger>
            <AccordionContent>
              <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
                <Droppable droppableId={`leagues-${country}`}>
                  {(provided) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className="space-y-2 p-4"
                    >
                      {countryLeagues.map((league, index) => (
                        <Draggable
                          key={league.id}
                          draggableId={league.id.toString()}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              className="flex items-center gap-4 p-4 bg-card rounded-lg border shadow-sm"
                            >
                              <div {...provided.dragHandleProps} className="cursor-grab">
                                <GripVertical className="h-5 w-5 text-muted-foreground" />
                              </div>
                              <span className="flex-1">{league.name}</span>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </>
  );
};
